module.exports = __webpack_public_path__ + "static/media/westVolunteer.5f1c8d5e.jpg";